/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable guard-for-in */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable complexity */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Observable, Subject } from 'rxjs';

export interface IEventDef {
    id: string;
    name: string;
    label?: string;
    type?: string;
    outcome?: string;
    zone?: string;
}

export interface IEventTreeData {
    defId?: string;
    vidId?: string;
    flags?: string[];
    [key: string]: string | number | string[] | undefined;
}

export interface IPlayerInfo {
    playerId: string;
    position: string;
    number: number;
}

export interface ITeamInfo {
    teamId: string;
    players: IPlayerInfo[];
}

export interface IGameContext {
    applicationId: number;
    gameId: string;
    team1: ITeamInfo;
    team2: ITeamInfo;
    period: number;
    videoId: string;
    setDefaultFlags?: boolean;
}

export interface IPositional {
    position: number;
    label: string;
    shortcut?: string;
    helpText?: string;
    isSelected?: boolean; // undefined = false;
}

export interface IDisplayInfo {
    matrixMessage?: string;
    matrixHelpText?: string;
    matrixItems?: IPositional[];
    steps?: IEventStep[];
    isDone: boolean;
    isPersistable: boolean;
    isExisting: boolean;
    canGoBack: boolean;
    location?: IHistoryLocation;
    missingFields?: IMissingField[];
    eventData?: IEventTreeData;
    flags?: string[];
    teamId?: string;
    playerId?: string;
    error?: string;
    frame?: number;
    xRinkCoord?: number;
    yRinkCoord?: number;
}

export interface IMissingField {
    id: number;
    fieldName: string;
    semantics?: Semantics;
    error: string;
}

interface IOption extends IPositional {
    value: string;
}

interface IStepPrompt {
    id: number;
    fieldName: string;
    semantics?: Semantics;
    prompt: string;
    helpText?: string;
    defaultValue?: string;
    options: IOption[];
    required: boolean;
    value?: string;
}

export interface IEventStep extends IPositional {
    id: number;
    hasValue: boolean;
    isValid: boolean;
    semantics?: Semantics;
}

interface INextEvent extends IPositional {
    id: number;
    required: boolean;
}

interface ILocalOptionData {
    label?: string;
    value?: string; // = ""
    position?: number;
    shortcut?: string;
}

interface IOptionData extends ILocalOptionData {
    option_index: number;
}

interface IFieldData {
    field_type?: string; // = "field"
    name: string;
    output_field_name?: string;
    data_type?: string; // = "text"
    semantics?: Semantics;
    is_ubiquitous?: boolean; // = False
    init_value?: string;
    true_if_flags?: string[];
    options?: IOptionData[]; // = []
    getValueMethod?: (state: EventState) => string | undefined;
}

interface IConditionalData {
    conditions?: Record<string, string>;
}

interface IVariantData extends IConditionalData {
    allowed_values?: string[];
    default_value?: string;
    local_options?: ILocalOptionData[];
    set_fields?: Record<string, string | undefined>;
    title?: string;
    prompt?: string;
    help_text?: string;
    is_visible?: boolean;
    is_used?: boolean;
    is_required?: boolean;
    output_data_field?: boolean;
    evaluation_order?: number;
}

interface IStepData {
    data_field: string;
    output_data_field?: boolean; // = True
    title: string;
    prompt?: string;
    help_text?: string;
    is_visible?: boolean; // = True
    is_used?: boolean; // = True
    is_required?: boolean; // = True
    display_order?: number; // = 0
    init_value?: string;
    variants?: IVariantData[]; // = []
}

interface INextEventData extends IConditionalData {
    target_class_name?: string;
    event_name: string;
    zone?: string;
    type?: string;
    outcome?: string;
    label?: string;
    help_text?: string;
    copy_fields?: Record<string, string>;
    set_flags?: string[];
    set_fields?: Record<string, string>;
    is_required?: boolean; // = True
    position?: number;
    shortcut?: string;
}

interface IEventClassData {
    name: string;
    parent?: string;
    label: string;
    event_names: string[];
    is_persistable?: boolean; // = True
    use_as_empty?: boolean; // = False
    set_flags?: string[];
    steps?: IStepData[]; // = []
    next_events?: INextEventData[];
}

interface IEventCategoryData {
    label: string;
    help_text?: string;
    is_visible?: boolean; // = True
    is_quick?: boolean; // = False
    position?: number; // = 0
    shortcut?: string;
    events?: IEventData[];
}

interface IEventData {
    label: string;
    help_text?: string;
    event_name?: string;
    event_class_name?: string;
    is_visible?: boolean; // = True
    position?: number; // = 0
    type?: string;
    outcome?: string;
    shortcut?: string;
    set_flags?: string[];
}

interface IHistoryLocation {
    type: PositionalTypes;
    code?: string;
    step?: IEventStep;
}

interface INewEvent extends IPositional {
    name: string;
    type?: string;
    outcome?: string;
    flags?: string[];
    isQuick: boolean;
}

interface IEventCategory extends IPositional {
    events: INewEvent[];
}

export interface IData {
    data_fields: IFieldData[];
    classes: IEventClassData[];
    categories?: IEventCategoryData[];
}

/* ! last modified on 2025-12-16 10:33:31.148767 */
export const API_VERSION = 25121000;

export enum Semantics {
    Category = 'category',
    EventName = 'event_name',
    Zone = 'zone',
    PlayerId = 'player_id',
    TeamId = 'team_id',
    GoalieId = 'goalie_id',
    Period = 'period',
    LocationX = 'location_x',
    LocationY = 'location_y',
    LocationXY = 'location_xy',
    Frame = 'frame',
    VideoId = 'video_id',
    Separator = 'separator',
}

export enum PositionalTypes {
    Option = 'IOption',
    Event = 'INewEvent',
    Category = 'IEventCategory',
    Recommended = 'INextEvent',
    Step = 'IEventStep',
}

enum FieldTypes {
    Field = 'field',
    FlagBoolean = 'flag_boolean',
    FlagSelection = 'flag_selection',
    Special = 'special',
    Derived = 'derived',
}

const DISABLED_STEPS = [Semantics.LocationXY, Semantics.PlayerId, Semantics.Frame, Semantics.TeamId, Semantics.LocationX, Semantics.LocationY];

const EVENT_DEF_ID = 'defId';
const EVENT_NAME = 'event_name';
const EVENT_TYPE = 'type';
const EVENT_OUTCOME = 'outcome';
const EVENT_ZONE = 'zone';
const SEPARATOR_STEP_ID = 0;
const CATEGORY_STEP_ID = 1;
export const KEYBOARD_SHORTCUTS = ['Q', 'W', 'E', 'R', 'A', 'S', 'D', 'F', 'Z', 'X', 'C', 'V'];

const ANY_FLAG_PRESENT: IFieldData = { field_type: FieldTypes.Special, name: 'ANY_FLAG_PRESENT' };
const ALL_FLAGS_PRESENT: IFieldData = { field_type: FieldTypes.Special, name: 'ALL_FLAGS_PRESENT' };
const ANY_FLAG_MISSING: IFieldData = { field_type: FieldTypes.Special, name: 'ANY_FLAG_MISSING' };
const ALL_FLAGS_MISSING: IFieldData = { field_type: FieldTypes.Special, name: 'ALL_FLAGS_MISSING' };
const PLAYER_POSITION: IFieldData = {
    field_type: FieldTypes.Derived,
    name: 'PLAYER_POSITION',
    getValueMethod: (state: EventState): string | undefined => {
        const playerId = state.getValueBySemantics(Semantics.PlayerId);
        if (playerId) {
            const teamId = state.getValueBySemantics(Semantics.TeamId);
            return state.getPlayerInfo(teamId, playerId)?.position;
        }
        return undefined;
    }
};

const specialFields = [ANY_FLAG_PRESENT, ALL_FLAGS_PRESENT, ANY_FLAG_MISSING, ALL_FLAGS_MISSING, PLAYER_POSITION];
const STEP_SEPARATOR: IEventStep = { id: SEPARATOR_STEP_ID, label: '|', hasValue: true, isValid: true, semantics: Semantics.Separator, position: 0 };
const OTHERS: INextEvent = { id: 0, label: 'others...', position: 11, required: false, shortcut: 'V' };

class FieldsCache {
    private static _maxId = 0;
    private _list: Record<string, IFieldData> = {};
    private _ubqFields?: IFieldData[] = undefined;

    constructor(fields: IFieldData[]) {
        for (const field of fields) {
            this._list[field.name] = field;
            if (field.field_type === FieldTypes.Derived && field.getValueMethod === undefined) {
                field.getValueMethod = FieldsCache.getDefaultGetMethod(field.semantics);
            }
        }
    }

    public getField(name: string): IFieldData {
        const field = this._list[name] ?? specialFields.find(x => x.name === name);
        if (field) {
            return field;
        }
        throw new Error(`Field ${name} not found`);
    }

    public getByOutput(name: string, fieldNames: string[]): IFieldData | undefined {
        for (const [, field] of Object.entries(this._list)) {
            if ((field.output_field_name ?? field.name) === name && fieldNames.includes(name)) {
                return field;
            }
        }
        return undefined;
    }

    public getByFlag(flag: string, fieldNames: string[]): IFieldData {
        for (const [name, field] of Object.entries(this._list)) {
            if (FieldsCache.isFlag(field)
                && fieldNames.includes(name) && field.options?.find(x => x.value === flag) !== undefined) {
                return field;
            }
        }
        throw new Error(`Field with flag: ${flag} not found or not part of the event_class.`);
    }

    public getOpposing(context: IGameContext, name: string, value?: string): string | undefined {
        const field = this.getField(name);
        if (field.semantics === Semantics.TeamId) {
            return value === context.team2.teamId ? context.team1.teamId : (value === context.team1.teamId ? context.team2.teamId : undefined);
        }
        if (field.options)
            for (let i = 0; i < field.options.length; i++) {
                if (field.options[i].value === value) {
                    return field.options[field.options.length - i - 1].value;
                }
            }
        return undefined;
    }

    public getGoalieId(context: IGameContext, teamId: string): string | undefined {
        let team: ITeamInfo | undefined;
        if (context.team1.teamId === teamId) {
            team = context.team1;
        } else if (context.team2.teamId === teamId) {
            team = context.team2;
        }
        if (team) {
            for (const player of team.players) {
                if (player.position === 'G') {
                    return player.playerId;
                }
            }
        }
        return undefined;
    }

    public getOptionLabel(field: IFieldData, title: string, value?: string): string {
        if (field.field_type === FieldTypes.FlagBoolean) {
            return value ? `${title}+` : `${title}-`;
        } else {
            const dvalue = field.options?.find(x => x.value === value);
            return dvalue ? dvalue.label ?? dvalue.value ?? '' : (value ?? title);
        }
    }

    public getUbqFields(): IFieldData[] {
        if (!this._ubqFields) {
            this._ubqFields = [];
            for (const [, field] of Object.entries(this._list)) {
                if (field.is_ubiquitous) {
                    this._ubqFields.push(field);
                }
            }
        }
        return this._ubqFields;
    }

    public static getLocalOption(option: ILocalOptionData, index: number): IOption {
        const position = (option.position === undefined || option.position > -1 ? option.position : undefined) ?? index;
        const result = {
            position: position,
            label: option.label ?? option.value ?? '',
            value: option.value ?? '',
            shortcut: FieldsCache.getShortcut(option.shortcut, position)
        };
        return result;
    }

    public getOptions(field: IFieldData, sublist?: string[]): IOption[] {
        if (sublist && sublist.length > 0 && field.options && field.options.length > 0) {
            const result: IOption[] = [];
            for (let index = 0; index < sublist.length; index++) {
                const sections = sublist[index].split('::');
                const option = field.options.find(x => x.value === sections[0]);
                if (option) {
                    const r = FieldsCache.getLocalOption(option, index);
                    if (sections.length > 1 && !Number.isNaN(parseInt(sections[1]))) {
                        r.position = parseInt(sections[1]);
                        r.shortcut = FieldsCache.getShortcut(undefined, r.position);
                    }
                    result.push(r);
                }
            }
            return result;
        }

        return field.options?.map((x, index) => FieldsCache.getLocalOption(x, index)) ?? [];
    }

    public static isFlag(field?: IFieldData): boolean {
        const fieldType = field?.field_type;
        return fieldType === FieldTypes.FlagBoolean || fieldType === FieldTypes.FlagSelection;
    }

    public static isField(field?: IFieldData): boolean {
        const fieldType = field?.field_type;
        return fieldType === undefined || fieldType === FieldTypes.Field;
    }

    public static newId(): number {
        return ++FieldsCache._maxId;
    }

    private static getDefaultGetMethod(semantics?: Semantics): ((state: EventState) => string | undefined) | undefined {
        switch (semantics) {
            case Semantics.LocationXY:
                return (state: EventState): string | undefined => {
                    const x = state.getValueBySemantics(Semantics.LocationX);
                    if (x) {
                        const y = state.getValueBySemantics(Semantics.LocationY);
                        if (y) {
                            return 'XY';
                        }
                    }
                    return undefined;
                };
        }
        return undefined;
    }

    public static getShortcut(shortcut: string | undefined, position: number): string | undefined {
        if (shortcut && shortcut.length !== 0) {
            return shortcut;
        }
        if (position >= 0 && position < KEYBOARD_SHORTCUTS.length) {
            return KEYBOARD_SHORTCUTS[position];
        }
        return undefined;
    }
}

class EventStateValue {
    public label = '';
    constructor(e: EventState, public name: string, public value?: string, public semantics?: Semantics, step?: Step) {
        if (step) {
            this.setLabel(e, step);
        }
    }

    public setLabel(e: EventState, step: Step): void {
        if (this.label === '' && step.field) {
            if (this.value && (step.field.semantics === Semantics.PlayerId || step.field.semantics === Semantics.GoalieId)) {
                const info = e.getPlayerInfo(undefined, this.value);
                if (info) {
                    this.label = info.number.toString();
                    return;
                }
            }
            const v = e.variants[step.id];
            this.label = step.fields?.getOptionLabel(step.field, v?.title ?? step.title, this.value) ?? '';
        }
    }
}

class EventState {
    private _eventClass?: EventClass;
    private _data: Record<string, EventStateValue> = {};
    public variants: Record<number, Variant | undefined> = {};

    constructor(eventClass: EventClass | undefined, public fields: FieldsCache, public context: IGameContext, public previous?: EventState) {
        if (eventClass) {
            this.setEventClass(eventClass);
        }
    }

    public setEventClass(eventClass: EventClass): void {
        this._eventClass = eventClass;
        this.setVariants();
    }

    public setEventLabel(eventLabel: string): void {
        const sValue = this.getStateValue(EVENT_NAME);
        if (sValue) {
            sValue.label = eventLabel;
        }
    }

    public setValue(field: IFieldData, value?: string, step?: Step): void {
        const fieldName = field.name;
        if (step === undefined) {
            step = this._eventClass?.allSteps.find(x => x.fieldName === fieldName);
        }
        this._data[fieldName] = new EventStateValue(this, fieldName, value, field.semantics, step);
    }

    public setByName(fieldName: string, value?: string): void {
        const field = this.fields.getField(fieldName);
        if (field) {
            const step = this._eventClass?.allSteps.find(x => x.fieldName === fieldName);
            this._data[fieldName] = new EventStateValue(this, fieldName, value, field.semantics, step);
        }
    }

    public setVariants(startId?: number): void {
        if (this._eventClass) {
            if (startId === undefined) {
                this.variants = {};
                for (const step of this._eventClass.allSteps) {
                    this.variants[step.id] = step.getApplicableVariant(this, undefined);
                }
            } else {
                let shouldSet = false;
                for (const step of this._eventClass.allSteps) {
                    if (shouldSet) {
                        this.variants[step.id] = step.getApplicableVariant(this, this.variants[step.id]);
                    }
                    if (step.id === startId) {
                        shouldSet = true;
                    }
                }
            }
        }
    }

    public getValue(fieldName: string): string | undefined {
        return this.getStateValue(fieldName)?.value;
    }

    public getStateValue(fieldName: string, field?: IFieldData): EventStateValue | undefined {
        field = field ?? this.fields.getField(fieldName);
        if (field?.field_type === FieldTypes.Derived && field.getValueMethod !== undefined) {
            const value = field.getValueMethod(this);
            return value ? new EventStateValue(this, fieldName, value, field.semantics) : undefined;
        }
        return this._data[fieldName];
    }

    public getStepBySemantics(semantics: Semantics): Step | undefined {
        if (this._eventClass) {
            for (const step of this._eventClass.allSteps) {
                if (step.field?.semantics === semantics) {
                    if (step.getUsed(this.variants[step.id])) {
                        return step;
                    }
                }
            }
        }
        return undefined;
    }

    public getValueBySemantics(semantics: Semantics): string | undefined {
        for (const key in this._data) {
            const value = this._data[key];
            if (value?.semantics === semantics) {
                return value.value;
            }
        }
        return undefined;
    }

    public hasValue(fieldName: string): boolean {
        return this.getStateValue(fieldName) !== undefined;
    }

    private initValues(): void {
        this._data = {};
        if (this._eventClass) {
            for (const step of this._eventClass.allSteps) {
                if (step.field) {
                    let value;
                    switch (step.field.semantics) {
                        case Semantics.Period:
                            value = this.context.period.toString();
                            break;
                        case Semantics.VideoId:
                            value = this.context.videoId;
                            break;
                        default:
                            value = step.initValue ?? step.field.init_value;
                            break;
                    }
                    if (value) {
                        this.setValue(step.field, value, step);
                    }
                }
            }
        }
    }

    private trueIfFlags(): void {
        if (this._eventClass) {
            for (const step of this._eventClass.allSteps) {
                if (step.field?.true_if_flags && step.field.true_if_flags.length > 0) {
                    const value = this.getValue(step.field.name);
                    if (value !== 'true') {
                        if (this.containsAny(step.field.true_if_flags)) {
                            this.setValue(step.field, 'true', step);
                        }
                    }
                }
            }
        }
    }

    public getOutputFields(): IFieldData[] {
        const fields: IFieldData[] = [];
        if (this._eventClass) {
            for (const step of this._eventClass.allSteps) {
                if (step.field) {
                    const v = this.variants[step.id];
                    if (step.getOutputField(v)) {
                        fields.push(step.field);
                    }
                }
            }
        }
        return fields;
    }

    public getEventData(eventDefs?: IEventDef[]): IEventTreeData {
        const e = new EventDataHelper({});
        e.setValue('gameId', this.context.gameId);
        for (const field of this.getOutputFields()) {
            const value = this.getValue(field.name);
            if (value !== undefined) {
                if (FieldsCache.isField(field)) {
                    switch (field.data_type) {
                        case 'int':
                            e.setValue(field.output_field_name ?? field.name, parseInt(value));
                            break;
                        case 'float':
                            e.setValue(field.output_field_name ?? field.name, parseFloat(value));
                            break;
                        default:
                            e.setValue(field.output_field_name ?? field.name, value);
                    }
                } else if (FieldsCache.isFlag(field) && value !== '') {
                    if (value.startsWith('-')) {
                        e.removeFlag(value.substring(1));
                    } else {
                        e.addFlag(value);
                    }
                }
            }
        }
        if (eventDefs) {
            this.setEventId(e, eventDefs);
        }
        return e.data;
    }

    private setEventId(e: EventDataHelper, eventDefs: IEventDef[]): void {
        switch (this.context.applicationId) {
            case 1: // playerevents:
                return EventState.setEventId1(e, eventDefs);
            case 2: // gameevents:
                return EventState.setEventId2(e, eventDefs);
            case 3: // playershiftevents:
                return EventState.setEventId3(e, eventDefs);
        }
    }

    // playerevents:
    private static setEventId1(e: EventDataHelper, eventDefs: IEventDef[]): void {
        const name = e.getValueStr(EVENT_NAME);
        const type = e.getValueStr(EVENT_TYPE);
        const zone = e.getValueStr(EVENT_ZONE);
        const outcome = e.getValueStr(EVENT_OUTCOME);
        const id = eventDefs.find(x => x.name === name && x.type === type && x.outcome === outcome && x.zone === zone)?.id;
        if (id) {
            e.setValue(EVENT_DEF_ID, id);
            e.removeValue(EVENT_NAME);
            e.removeValue(EVENT_TYPE);
            e.removeValue(EVENT_ZONE);
            e.removeValue(EVENT_OUTCOME);
        }
    }

    // gameevents
    private static setEventId2(e: EventDataHelper, eventDefs: IEventDef[]): void {
        const name = e.getValueStr(EVENT_NAME);
        const type = e.getValueStr(EVENT_TYPE);
        const id = eventDefs.find(x => x.name === name && x.type === type)?.id;
        if (id) {
            e.setValue(EVENT_DEF_ID, id);
            e.removeValue(EVENT_NAME);
            e.removeValue(EVENT_TYPE);
        }
    }

    // playershiftevents
    private static setEventId3(e: EventDataHelper, eventDefs: IEventDef[]): void {
        const name = e.getValueStr(EVENT_NAME);
        const id = eventDefs.find(x => x.name === name)?.id;
        if (id) {
            e.setValue(EVENT_DEF_ID, id);
            e.removeValue(EVENT_NAME);
        }
    }

    public fill(e: EventDataHelper, existing: boolean): void {
        this.initValues();
        if (!this._eventClass) {
            return;
        }

        const fieldNames = this._eventClass.allSteps.filter(x => x.field).map(x => x.fieldName);

        if (this._eventClass.setFlags) {
            this._eventClass.setFlags.forEach(flag => {
                this.setValue(this.fields.getByFlag(flag, fieldNames), flag);
            });
        }

        for (const key in e.data) {
            const value = e.getValueStr(key);
            if (value) {
                const field = this.fields.getByOutput(key, fieldNames);
                if (field) {
                    this.setValue(field, value);
                }
            }
        }

        e.flags.forEach(flag => {
            this.setValue(this.fields.getByFlag(flag, fieldNames), flag);
        });

        if (existing) {
            this._eventClass.allSteps.forEach(step => {
                const field = step.field;
                if (field && !this.hasValue(field.name)) {
                    if (FieldsCache.isFlag(field)) {
                        const empty = field.options?.find(x => x.value === '') ? '' : undefined;
                        this._data[field.name] = new EventStateValue(this, field.name, empty, field.semantics, step);
                    }
                }
            });
        }

        this.trueIfFlags();
        this.setVariants();
    }

    public isValueInList(fieldName: string, values: string[]): boolean {
        let value = this.getValue(fieldName);
        if (!value || value.length === 0) {
            value = 'NULL';
        }
        return values.includes(value);
    }

    public containsAny(values: string[]): boolean {
        for (const key in this._data) {
            const value = this._data[key]?.value;
            if (value && values.includes(value)) {
                return true;
            }
        }
        return false;
    }

    public containsValue(value: string): boolean {
        for (const key in this._data) {
            const cvalue = this._data[key]?.value;
            if (cvalue === value) {
                return true;
            }
        }
        return false;
    }

    public containsAll(values: string[]): boolean {
        for (const x of values) {
            if (!this.containsValue(x)) {
                return false;
            }
        }
        return true;
    }

    public getTeamInfo(teamId: string): ITeamInfo | undefined {
        if (teamId === this.context.team1.teamId) {
            return this.context.team1;
        }
        if (teamId === this.context.team2.teamId) {
            return this.context.team2;
        }
        return undefined;
    }

    public getPlayerInfo(teamId: string | undefined, playerId: string): IPlayerInfo | undefined {
        if (teamId === undefined) {
            return this.context.team1.players.find((x => x.playerId === playerId)) ??
                this.context.team2.players.find((x => x.playerId === playerId));
        }
        return this.getTeamInfo(teamId)?.players.find((x => x.playerId === playerId));
    }

    public getTeamIdByPlayerId(playerId: string): string | undefined {
        if (this.context.team1.players.some(x => x.playerId === playerId)) {
            return this.context.team1.teamId;
        }
        if (this.context.team2.players.some(x => x.playerId === playerId)) {
            return this.context.team2.teamId;
        }
        return undefined;
    }

    public validate(semantics: Semantics, fieldName: string, rawValue: string): string | undefined {
        switch (semantics) {
            case Semantics.PlayerId:
                if (this.getPlayerInfo(this.getValueBySemantics(Semantics.TeamId), rawValue) === undefined) {
                    return `'${rawValue}' is not valid value for ${fieldName}`;
                }
                break;
            case Semantics.TeamId:
                if (rawValue !== this.context.team1.teamId && rawValue !== this.context.team2.teamId) {
                    return `'${rawValue}' is not valid value for ${fieldName}`;
                }
                break;
        }
        return undefined;
    }
}

class EventDataHelper {
    public flags: string[] = [];
    constructor(public data: IEventTreeData, eventDefs?: IEventDef[]) {
        if (this.data.flags) {
            this.flags = this.data.flags;
        } else {
            this.data.flags = this.flags;
        }

        if (eventDefs && EVENT_DEF_ID in this.data) {
            const defId = this.data[EVENT_DEF_ID];
            const def = eventDefs.find(x => x.id === defId);
            if (def) {
                this.data[EVENT_NAME] = def.name;
                if (def.type) {
                    this.data[EVENT_TYPE] = def.type;
                }
                if (def.outcome) {
                    this.data[EVENT_OUTCOME] = def.outcome;
                }
                if (def.zone) {
                    this.data[EVENT_ZONE] = def.zone;
                }
            }
        }
    }

    public getValue(fieldName: string): string | number | undefined {
        if (fieldName !== 'flags' && fieldName in this.data &&
            (typeof this.data[fieldName] === 'string' || typeof this.data[fieldName] === 'number')) {
            return this.data[fieldName];
        }
        return undefined;
    }

    public getValueStr(fieldName: string): string | undefined {
        const value = this.getValue(fieldName);
        return value ? String(value) : undefined;
    }

    public setValue(fieldName: string, value: string | number): void {
        if (fieldName === 'flags') {
            this.addFlag(String(value));
        } else {
            this.data[fieldName] = value;
        }
    }

    public removeValue(fieldName: string): void {
        delete this.data[fieldName];
    }

    public addFlag(flagName: string): void {
        if (!this.flags.includes(flagName)) {
            this.flags.push(flagName);
        }
    }

    public removeFlag(flagName: string): void {
        const i = this.flags.indexOf(flagName, 0);
        if (i > -1) {
            this.flags.splice(i, 1);
        }
    }
}

class Conditional {
    constructor(protected conditions?: Record<string, string>) { }

    public matchState(e: EventState): boolean {
        if (this.conditions) {
            let state: EventState | undefined;
            for (const [name, pattern] of Object.entries(this.conditions)) {
                let fieldName = name;
                if (fieldName.startsWith('previous.')) {
                    fieldName = fieldName.slice('previous.'.length);
                    state = e.previous;
                } else {
                    state = e;
                }
                if (!Conditional.match(fieldName, pattern, state)) {
                    return false;
                }
            }
        }
        return true;
    }

    private static match(fieldName: string, pattern: string, e: EventState | undefined): boolean {
        const isNot = pattern.startsWith('!');
        if (isNot) {
            pattern = pattern.slice(1);
        }

        const result = Conditional.doMatch(fieldName, pattern, e);
        return isNot ? !result : result;
    }

    private static doMatch(fieldName: string, pattern: string, e: EventState | undefined): boolean {
        if (pattern === undefined || pattern.length === 0) {
            return true;
        }

        if (!e) {
            return false;
        }

        const values = pattern.includes('|') ? pattern.split('|') : [pattern];

        switch (fieldName) {
            case ANY_FLAG_PRESENT.name:
                return e.containsAny(values);
            case ALL_FLAGS_PRESENT.name:
                return e.containsAll(values);
            case ANY_FLAG_MISSING.name:
                return !e.containsAll(values);
            case ALL_FLAGS_MISSING.name:
                return !e.containsAny(values);
            default:
                return e.isValueInList(fieldName, values);
        }
        return false;
    }

    public static deepCopy<T>(obj: T): T {
        if (typeof obj !== 'object' || obj === null || obj === undefined) {
            return obj;
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const copy: any = Array.isArray(obj) ? [] : {};

        for (const key in obj) {
            if (Object.hasOwn(obj, key)) {
                copy[key] = Variant.deepCopy(obj[key]);
            }
        }
        return copy as T;
    }
}

class Variant extends Conditional {
    public prompt?: IStepPrompt;

    constructor(public fields: FieldsCache, public id: number, private _data: IVariantData, public isAuto?: boolean) {
        super(_data.conditions);
    }

    public static create(fields: FieldsCache, data: IVariantData): Variant {
        return new Variant(fields, FieldsCache.newId(), data, false);
    }

    public get title(): string | undefined {
        return this._data.title;
    }

    public get used(): boolean | undefined { return this._data.is_used; }
    public get visible(): boolean | undefined { return this._data.is_visible; }
    public get required(): boolean | undefined { return this._data.is_required; }
    public get outputField(): boolean | undefined { return this._data.output_data_field; }

    public getPrompt(stepId: number, field: IFieldData, prompt: string, required: boolean, helpText?: string): IStepPrompt {
        if (!this.prompt) {
            let options: IOption[] | undefined;
            if (this._data.local_options) {
                options = this._data.local_options?.map((x: ILocalOptionData, index: number) => FieldsCache.getLocalOption(x, index));
            }
            if (!options) {
                options = this.fields.getOptions(field, this._data.allowed_values);
            }

            this.prompt = {
                id: stepId,
                fieldName: field.name,
                semantics: field.semantics,
                prompt: this._data.prompt ?? prompt,
                helpText: this._data.help_text ?? helpText,
                defaultValue: this._data.default_value,
                options: options,
                required: this._data.is_required ?? required
            };
        }
        return this.prompt;
    }

    public clone(): Variant {
        const v = new Variant(this.fields, this.id, this._data, this.isAuto);
        v.prompt = this.prompt;
        return v;
    }

    public validate(e: EventState, fieldName: string, required: boolean, rawValue?: string): string | undefined {
        if (this.prompt) {
            if (this.prompt.options && this.prompt.options.length > 0) {
                rawValue = rawValue ?? '';
                if (!this.prompt.options.find(x => x.value === rawValue)) {
                    return `'${rawValue}' is not valid value for ${fieldName}.`;
                }
            } else if (this.prompt.semantics && rawValue) {
                return e.validate(this.prompt.semantics, fieldName, rawValue);
            }
        }
        if (required && rawValue === undefined) {
            return `${fieldName} is required.`;
        }
        return undefined;
    }

    public setDefaultValue(e: EventState, step: Step): void {
        const field = step.field;
        if (field && this.prompt) {
            if (this.prompt.options?.length === 1) {
                e.setValue(field, this.prompt.options[0].value, step);
            } else if (this.prompt.defaultValue !== undefined && !e.hasValue(field.name)) {
                if (FieldsCache.isField(field) || (FieldsCache.isFlag(field) && (e.context.setDefaultFlags ?? false))) {
                    e.setValue(field, this.prompt.defaultValue, step);
                }
            }
        }

        if (this._data.set_fields) {
            for (const [name, value] of Object.entries(this._data.set_fields)) {
                e.setValue(e.fields.getField(name), value);
            }
        }
    }
}

class Step {
    public fields?: FieldsCache;
    public field?: IFieldData;

    constructor(public id: number, private _data: IStepData, public variants: Variant[]) {
    }

    public get fieldName(): string { return this._data.data_field; }
    public get outputField(): boolean { return this._data.output_data_field ?? true; }
    public get title(): string { return this._data.title; }
    public get visible(): boolean { return this._data.is_visible ?? true; }
    public get used(): boolean { return this._data.is_used ?? true; }
    public get required(): boolean { return this._data.is_required ?? true; }
    public get order(): number { return this._data.display_order ?? 0; }
    public get initValue(): string | undefined { return this._data.init_value; }

    public static create(data: IStepData, fields: FieldsCache): Step {
        let variants: Variant[];
        if (data.variants && data.variants.length > 0) {
            variants = data.variants.map(x => Variant.create(fields, x));
        } else {
            variants = [new Variant(fields, FieldsCache.newId(), {}, true)];
        }

        const newStep = new Step(FieldsCache.newId(), data, variants);
        newStep.init(fields);
        return newStep;
    }

    public init(fields: FieldsCache) {
        this.fields = fields;
        this.field = this.fields.getField(this.fieldName);
        if (this.field) {
            this.variants.forEach(x => x.getPrompt(this.id, this.field!, this._data.prompt ?? x.title ?? this.title, this.required, this._data.help_text));
        }
    }

    public clone(): Step {
        const newStep = new Step(this.id, this._data, this.variants.map(x => x.clone()));
        newStep.fields = this.fields;
        newStep.field = this.field;
        return newStep;
    }

    public getApplicableVariant(e: EventState, existing?: Variant): Variant | undefined {
        for (const v of this.variants) {
            if (v.matchState(e)) {
                if (this.field) {
                    if (v !== existing) {
                        v.setDefaultValue(e, this);
                    }
                }
                return v;
            }
        }
        return undefined;
    }

    public getRequired(v?: Variant): boolean {
        return v?.required ?? this.required;
    }

    public getUsed(v?: Variant): boolean {
        return v?.used ?? this.used;
    }

    public getVisible(v?: Variant): boolean {
        if (!this.getUsed(v)) {
            return false;
        }
        return v?.visible ?? this.visible;
    }

    public getHidden(v?: Variant): boolean {
        if (!this.getUsed(v)) {
            return false;
        }
        return !(v?.visible ?? this.visible);
    }

    public getOutputField(v?: Variant): boolean {
        if (!this.getUsed(v)) {
            return false;
        }
        return v?.outputField ?? this.outputField;
    }

    public getUIStep(e: EventState, v?: Variant): IEventStep {
        const semantics = this.field?.semantics;
        const stateValue = e.getStateValue(this.fieldName, this.field);
        if (stateValue) {
            stateValue.setLabel(e, this);
            return { id: this.id, label: stateValue.label, hasValue: true, isValid: this.validate(e, v, stateValue.value) === undefined, semantics: semantics, position: 0 };
        }
        return { id: this.id, label: v?.title ?? this.title, hasValue: false, isValid: !this.getRequired(v), semantics: semantics, position: 0 };
    }

    public validate(e: EventState, v?: Variant, rawValue?: string): string | undefined {
        return v?.validate(e, this.field?.name ?? v?.title ?? this.title, v?.required ?? this.required, rawValue);
    }

    public overrideParent(pStep: Step): Step {
        let variants = this.variants;
        if (variants.length === 0 || (this.variants.length === 1 && this.variants[0].isAuto && (pStep.variants.length > 1 || !pStep.variants[0].isAuto))) {
            variants = pStep.variants;
        }

        variants = variants.map(x => x.clone());
        const newData = Conditional.deepCopy(this._data);
        newData.title = newData.title ?? pStep.title;
        const newStep = new Step(this.id, newData, variants);
        newStep.fields = this.fields;
        newStep.field = this.field;
        for (const v of newStep.variants) {
            if (v.prompt) {
                v.prompt.id = newStep.id;
            }
        }
        return newStep;
    }

    public getMissing(e: EventState): IMissingField | undefined {
        const v = e.variants[this.id];
        if (!this.getUsed(v)) {
            return undefined;
        }
        if (e.hasValue(this.fieldName)) {
            const rawValue = e.getValue(this.fieldName);
            const error = this.validate(e, v, rawValue);
            if (error) {
                return { id: this.id, semantics: this.field?.semantics, fieldName: this.fieldName, error: error };
            }
        } else if (this.getRequired(v)) {
            return { id: this.id, semantics: this.field?.semantics, fieldName: this.fieldName, error: 'Required field missing value.' };
        }
        return undefined;
    }
}

class Next extends Conditional {
    public ui: INextEvent;
    private _eventData: IEventTreeData;
    constructor(public id: number, private _data: INextEventData) {
        super(_data.conditions);
        this.ui = {
            id: this.id,
            label: this._data.label ?? this._data.event_name,
            helpText: this._data.help_text ?? 'Recommended Event',
            required: this.required,
            position: this._data.position ?? -1,
            shortcut: this._data.shortcut ?? ''
        };
        this._eventData = {};
        this._eventData[EVENT_NAME] = this._data.event_name;
        if (this._data.type) {
            this._eventData[EVENT_TYPE] = this._data.type;
        }
        if (this._data.outcome) {
            this._eventData[EVENT_OUTCOME] = this._data.outcome;
        }
        if (this._data.zone) {
            this._eventData[EVENT_ZONE] = this._data.zone;
        }
    }

    public get required(): boolean { return this._data.is_required ?? true; }
    public get eventName(): string {
        if (typeof this._eventData[EVENT_NAME] === 'string') {
            return this._eventData[EVENT_NAME];
        }
        return '';
    }
    public get targetClassName(): string | undefined { return this._data.target_class_name; }

    public static create(data: INextEventData): Next {
        return new Next(FieldsCache.newId(), data);
    }

    public getState(context: IGameContext, eventClass: EventClass, e: EventState): EventState {
        const state = new EventState(eventClass, e.fields, context, e);
        const dataHelper = new EventDataHelper(this._eventData);
        state.fill(dataHelper, false);

        // Carry the source event's frame onto the next event by default so recommended events that
        // do not remap it via copy_fields still inherit the playhead. Any copy_fields entry for the
        // frame (e.g. increment_int for a one-touch pass) runs below and overrides this default.
        const frameField = eventClass.allSteps.find(step => step.field?.semantics === Semantics.Frame)?.field;
        if (frameField) {
            const sourceFrame = e.getValueBySemantics(Semantics.Frame);
            if (sourceFrame !== undefined) {
                state.setValue(frameField, sourceFrame);
            }
        }

        if (this._data.copy_fields) {
            for (const [name, action] of Object.entries(this._data.copy_fields)) {
                let fieldName = name;
                let source: EventState | undefined = e;
                if (fieldName.startsWith('previous.')) {
                    source = e.previous ?? e;
                    fieldName = fieldName.slice('previous.'.length);
                }
                let value = source.getValue(fieldName);

                switch (action) {
                    case 'copy':
                        break;
                    case 'opposing':
                        value = e.fields.getOpposing(context, fieldName, value);
                        break;
                    case 'increment_int':
                        value = value ? ((+value) + 1).toString() : '1';
                        break;
                    case 'set_goalie':
                        // eslint-disable-next-line no-case-declarations
                        const teamId = state.getValueBySemantics(Semantics.TeamId);
                        value = teamId ? e.fields.getGoalieId(context, teamId) : undefined;
                        break;
                }
                state.setValue(e.fields.getField(fieldName), value);
            }
        }

        if (this._data.set_flags) {
            const fieldNames = eventClass.allSteps.filter(x => FieldsCache.isFlag(x.field)).map(x => x.fieldName);
            for (const flag of this._data.set_flags) {
                state.setValue(e.fields.getByFlag(flag, fieldNames), flag);
            }
        }

        if (this._data.set_fields) {
            for (const [fieldName, value] of Object.entries(this._data.set_fields)) {
                state.setValue(e.fields.getField(fieldName), value);
            }
        }
        state.setVariants();
        if (e.previous) {
            e.previous = undefined;
        }
        return state;
    }

    public getUI(index: number): INextEvent {
        const position = this.ui.position === 0 ? index : this.ui.position;
        return {
            id: this.ui.id,
            position: position,
            label: this.ui.label,
            shortcut: FieldsCache.getShortcut(this.ui.shortcut, position),
            helpText: this.ui.helpText,
            required: this.ui.required
        };
    }
}

class EventClass {
    public allSteps: Step[] = [];
    public allNextEvents: Next[] = [];
    private _parent?: EventClass;
    private _steps: Step[];
    private _nextEvents: Next[];

    constructor(public fields: FieldsCache, private _data: IEventClassData) {
        this._steps = _data.steps?.map(x => Step.create(x, fields)) ?? [];
        this._nextEvents = _data.next_events?.map(x => Next.create(x)) ?? [];
    }

    public get name(): string { return this._data.name; }
    public get parentName(): string | undefined { return this._data.parent; }
    public get eventNames(): string[] { return this._data.event_names; }
    public get persistable(): boolean { return this._data.is_persistable ?? true; }
    public get useAsEmpty(): boolean { return this._data.use_as_empty ?? false; }
    public get setFlags(): string[] | undefined { return this._data.set_flags; }

    public static create(fields: FieldsCache, data: IEventClassData): EventClass {
        return new EventClass(fields, data);
    }

    public init(fields: FieldsCache, parent?: EventClass) {
        this.fields = fields;
        this._parent = parent;
        for (const step of this._steps) {
            step.init(this.fields);
        }
        this.allSteps = [];
        this.allNextEvents = [];
        this.fillSteps(this.allSteps);
        this.fillNextEvents(this.allNextEvents);
        this.allSteps.sort((a, b) => a.order - b.order);
    }

    public getStep(id: number): Step | undefined {
        return this.allSteps.find(x => x.id === id);
    }

    public getNext(id: number): Next | undefined {
        return this.allNextEvents.find(x => x.ui.id === id);
    }

    private fillSteps(steps: Step[]): void {
        if (this._parent) {
            this._parent.fillSteps(steps);
        } else if (this.fields) {
            for (const field of this.fields.getUbqFields()) {
                const stepId = FieldsCache.newId();
                const step = new Step(stepId, { data_field: field.name, title: field.name, output_data_field: true, is_visible: false }, [
                    new Variant(this.fields, FieldsCache.newId(), {}, true)
                ]);
                step.init(this.fields);
                steps.push(step);
            }
        }

        if (this._steps) {
            for (const step of this._steps) {
                const i = steps.findIndex(x => x.fieldName === step.fieldName);
                if (i === -1) {
                    steps.push(step.clone());
                } else {
                    steps[i] = step.overrideParent(steps[i]);
                }
            }
        }
    }

    private fillNextEvents(nextEvents: Next[]): void {
        if (this._parent) {
            this._parent.fillNextEvents(nextEvents);
        }
        if (this._nextEvents) {
            nextEvents.push(...this._nextEvents);
        }
    }

    public static createID(classId: number, childIndex: number): number {
        return classId * 100 + childIndex;
    }
}

class EventClassesCache {
    public empty!: EventClass;
    private _classes: Record<string, EventClass>;

    constructor(list: EventClass[], public fields: FieldsCache) {
        let stillEmpty = true;
        this._classes = {};
        for (const eventClass of list) {
            this._classes[eventClass.name] = eventClass;
            if (stillEmpty && eventClass.useAsEmpty) {
                this.empty = eventClass;
                stillEmpty = false;
            }
        }
        for (const eventClass of list) {
            this.init_class(eventClass);
        }
        if (stillEmpty) {
            this.empty = new EventClass(fields, { name: 'empty', label: 'empty', event_names: [] });
        }
    }

    init_class(eventClass: EventClass): void {
        const pName = eventClass.parentName;
        const parent = pName !== undefined && pName.length > 0 ? this.getClass(pName) : undefined;
        if (parent && parent.fields === undefined) { // parent not initialized yet.
            this.init_class(parent);
        }
        eventClass.init(this.fields, parent);
    }

    getClass(name: string): EventClass {
        return this._classes[name] ?? this.empty;
    }

    selectClass(eventName: string): EventClass | undefined {
        for (const [, eventClass] of Object.entries(this._classes)) {
            if (eventClass.eventNames.includes(eventName)) {
                return eventClass;
            }
        }
        return undefined;
    }
}

class Stack<T> {
    private _items: T[];

    constructor() {
        this._items = [];
    }

    push(element: T): void {
        this._items.push(element);
    }

    pop(): T | undefined {
        if (this.isEmpty()) {
            return undefined; // Or throw an error
        }
        return this._items.pop();
    }

    peek(): T | undefined {
        if (this.isEmpty()) {
            return undefined;
        }
        return this._items[this._items.length - 1];
    }

    isEmpty(): boolean {
        return this._items.length === 0;
    }

    size(): number {
        return this._items.length;
    }

    clear(): void {
        this._items.length = 0;
    }
}

/** The main service class is EventTreeService used to process the event classes configuration during the editing of an event.
  */
export class EventTreeEngine {
    private _events: EventClassesCache;
    private _current: EventClass;
    private _state: EventState;
    private _existing = false;
    private _category?: IEventStep = undefined;
    private _browsedCategory?: IEventCategory = undefined;
    private _categories: IEventCategoryData[];
    private _displayCategories: IPositional[];
    private _editStepId?: number;
    private _userStepId?: number;
    private _historyLoc?: IHistoryLocation;
    private _historyStack = new Stack<IHistoryLocation>();
    private _delayedStart = false;
    private _displayInfoData?: IDisplayInfo;
    private _displayInfoSubject = new Subject<IDisplayInfo>();

    /**
     * Create a new instance of the EventTreeService class.
     * @param {IGameContext} _context - Specify information about the game being evented.
     * @param {string} configuration - Configuration data retrieved from the API or the data file.
     * @param {IEventDef[]} _eventDefs - List of event definitions retrieved from the RESTAPI corresponding to the current application_id (player_event_definitions, game_event_definitions or player_shift_event_definitions)
     */
    constructor(private _context: IGameContext, data: IData, private _eventDefs: IEventDef[]) {
        const fieldsCache = new FieldsCache(data.data_fields);
        this._events = new EventClassesCache(data.classes.map(x => EventClass.create(fieldsCache, x)), fieldsCache);
        this._current = this._events.empty;
        this._state = new EventState(this._current, this._events.fields, this._context, undefined);
        this._categories = data.categories ?? [];
        this._displayCategories = this.buildCategories();
    }

    /**
     * Returns the displayInfo Subject to subscribe to.
     * @returns {IDisplayInfo} the display info for the current situation.
     */
    public get displayInfo$(): Observable<IDisplayInfo> {
        return this._displayInfoSubject.asObservable();
    }

    /** Latest display info emitted by the engine, if any. */
    public get displayInfo(): IDisplayInfo | undefined {
        return this._displayInfoData;
    }

    /**
     * Start the editing process of a new event.
     * @param {IEventTreeData} previousEventData - Optional dictionary that contains the data of the event before the one to edit.
     */
    public startNewEvent(previousEventData?: IEventTreeData): void {
        if (previousEventData !== undefined) {
            this.startEvent(previousEventData, true);
        }
        this.updateInfo(this.startEvent({}, false, true));
    }

    /**
     * Start the editing process of an existing event.
     * @param {IEventTreeData} eventData - Object dictionary that contains the data of the event retrieved from the backend API. If the name field is not specified in eventData the empty event class is used.
     */
    public editEvent(eventData: IEventTreeData): void {
        this.updateInfo(this.startEvent(eventData, true, true));
    }

    /**
     * Set the internal value for a specific step (visible or hidden) using the fields semantics.
     * @param {string} semantics - the semantics of the field to set.
     * @param {string} value - string representation of the value.
     */
    public setValue(semantics: Semantics, value?: string): void {
        let error: string | undefined;
        if (semantics === Semantics.Category || semantics === Semantics.LocationXY) {
            error = `${semantics} field can't be set using this method.`;
        } else if (semantics === Semantics.PlayerId && this._historyLoc?.type === PositionalTypes.Recommended) {
            // While recommended next-events are shown, the engine's state still holds the
            // just-saved, already-complete event. Update the player on that state (so it carries
            // into whichever next event the user picks) but rebuild the recommended tiles rather
            // than falling through to getInfo(), which would see every field already filled and
            // immediately report isDone again, re-triggering an auto-save.
            const step = this._current.allSteps.find(x => x.field?.semantics === semantics);
            error = this.doSetValue(step, step?.field?.name ?? semantics, value);
            const info = this.doEventSaved(false);
            info.error = error;
            this.updateInfo(info);
            return;
        } else {
            this.checkDelayedStart();
            const step = this._current.allSteps.find(x => x.field?.semantics === semantics);
            error = this.doSetValue(step, step?.field?.name ?? semantics, value);
        }
        const info = this.getInfo();
        info.error = error;
        this.updateInfo(info);
    }

    /**
     * Retrieves the internal value for a specific step (visible or hidden) using the field semantics.
     * @param {string} semantics - the semantics of the field to retrieve.
     * @returns The internal value of the step.
     */
    public getValue(semantics: Semantics): string | undefined {
        if (semantics === Semantics.Category) {
            return this._category?.label;
        }
        return this._state.getValueBySemantics(semantics);
    }

    /**
     * Handle the click event of one of the displayInfo matrixItems array or the steps.
     * @param {IPositional} item - clicked item from the displayInfo.matrixItems array.
     */
    public itemClicked(item: IPositional): void {
        this.updateInfo(this.doItemClicked(item));
    }

    /**
     * Notify the service that saving of the event was completed. If there is an applicable next event that is required, it will be automatically started.
     */
    public eventSaved(addToHistory = true): void {
        this.updateInfo(this.doEventSaved(addToHistory, undefined));
    }

    /**
     * Handle the click of the back button.
     */
    public backClicked(): void {
        let info: IDisplayInfo | undefined;

        if (!this._historyStack.isEmpty()) {
            const historyloc = this._historyStack.pop();
            switch (historyloc?.type) {
                case PositionalTypes.Step:
                    if (historyloc.step) {
                        info = this.stepClicked(historyloc.step, false);
                    }
                    break;
                case PositionalTypes.Category:
                    if (historyloc.code === '') {
                        info = this.setHistory(this.setCategories(), false);
                    } else {
                        info = this.setHistory(this.setEvents(undefined, this._displayCategories.find(x => x.label === historyloc!.code) as IEventCategory), false);
                    }
                    break;
                case PositionalTypes.Recommended:
                    return this.eventSaved(false);
            }
        }
        if (!info) {
            info = this.getInfo(false);
        }

        this.updateInfo(info);
    }

    private startEvent(eventData: IEventTreeData, existing = true, resetHistory = true): IDisplayInfo {
        this._existing = existing;
        this._editStepId = undefined;
        this._userStepId = undefined;
        this._browsedCategory = undefined;
        const dataHelper = new EventDataHelper(eventData, this._eventDefs);
        this.selectEventClass(dataHelper.getValueStr(EVENT_NAME));
        this._state = new EventState(this._current, this._state.fields, this._context, this._state);
        this._state.setEventClass(this._current);
        this._state.fill(dataHelper, this._existing);
        this.setCategory();
        if (this._state.previous?.previous) {
            this._state.previous.previous = undefined;
        }
        if (resetHistory) {
            this.resetHistory();
        }
        return this.getInfo();
    }

    private doItemClicked(item: IPositional): IDisplayInfo {
        let errorMessage: string | undefined;
        switch (EventTreeEngine.getPositionalType(item)) {
            case PositionalTypes.Option:
            {
                const stepId = this._displayInfoData?.steps?.find(x => x.isSelected)?.id ?? 0;
                errorMessage = this.setValueById(stepId, (item as IOption).value);
                this._userStepId = undefined;
                break;
            }
            case PositionalTypes.Event:
                this.checkDelayedStart();
                return this.setHistory(this.setSelectedEvent(item as INewEvent, false), true);
            case PositionalTypes.Category:
                return this.setHistory(this.setEvents(undefined, item as IEventCategory), true);
            case PositionalTypes.Recommended:
            {
                const nextEvent = item as INextEvent;
                if (nextEvent.id === 0) { // others
                    this._delayedStart = true;
                    return EventTreeEngine.doNoEvent(this.setHistory(this.setCategories(undefined), true));
                }
                return this.startNextEvent(nextEvent.id);
            }
            case PositionalTypes.Step:
                return this.stepClicked(item as IEventStep, true);
        }

        const info = this.getInfo();
        info.error = errorMessage;
        return info;
    }

    private stepClicked(step: IEventStep, addToHistory = true): IDisplayInfo {
        if (!step.semantics || !DISABLED_STEPS.includes(step.semantics)) {
            if (this._userStepId === step.id) {
                this._userStepId = undefined;
            } else {
                this._userStepId = step.id;
            }
        }

        return this.getInfo(addToHistory);
    }

    private setSelectedEvent(event: INewEvent, clearData = true): IDisplayInfo {
        const data: IEventTreeData = clearData ? {} : this._state.getEventData();

        data[EVENT_NAME] = event.name;
        if (event.type) {
            data[EVENT_TYPE] = event.type;
        } else {
            delete data[EVENT_TYPE];
        }
        if (event.outcome) {
            data[EVENT_OUTCOME] = event.outcome;
        } else {
            delete data[EVENT_OUTCOME];
        }
        if (event.flags) {
            data.flags = [...event.flags];
        } else {
            delete data.flags;
        }
        return this.startEvent(data, false, false);
    }

    private checkDelayedStart(): void {
        if (this._delayedStart) {
            this._delayedStart = false;
            this.startEvent({}, false, true);
        }
    }

    private setValueById(stepId: number, value?: string): string | undefined {
        const step = this._current.getStep(stepId);
        return this.doSetValue(step, stepId.toString(), value);
    }

    private getValueByName(fieldName: string): string | undefined {
        return this._state.getValue(fieldName);
    }

    private getUISteps(): IEventStep[] {
        const result: IEventStep[] = [];
        let addCat = true;
        for (const step of this._current.allSteps) {
            const v = this._state.variants[step.id];
            if (step.getVisible(v)) {
                if (addCat && step.order > 0) {
                    addCat = false;
                    result.push(STEP_SEPARATOR);
                    result.push(this._category ?? { id: CATEGORY_STEP_ID, label: 'Category', hasValue: false, isValid: false, semantics: Semantics.Category, position: 0 });
                }
                result.push(step.getUIStep(this._state, v));
            }
        }
        return result;
    }

    private getNextStepId(): number | undefined {
        for (const step of this._current.allSteps) {
            if (step.order > 0) {
                const v = this._state.variants[step.id];
                if (step.getVisible(v) && step.getMissing(this._state) !== undefined) {
                    return step.id;
                }
            }
        }

        if (this._existing) {
            if (this._editStepId === undefined) {
                if (this.pickFirstFlag()) {
                    return this._editStepId;
                }
            } else {
                let search = false;
                for (const step of this._current.allSteps) {
                    if (search && this.pickVisibleFlag(step)) {
                        return this._editStepId;
                    }
                    if (!search && step.id === this._editStepId) {
                        search = true;
                    }
                }

                if (this.pickFirstFlag()) {
                    return this._editStepId;
                }
            }

            return this._state.getStepBySemantics(Semantics.EventName)?.id;
        }

        return undefined;
    }

    private getUIPrompt(stepId: number): IStepPrompt | undefined {
        if (stepId === CATEGORY_STEP_ID) {
            return this.getCategoryPrompt();
        }
        const step = this._current.getStep(stepId);
        const v = this._state.variants[stepId];
        if (v && step?.getVisible(v)) {
            const p = v.prompt;
            if (p) {
                p.value = this._state.getValue(step.fieldName);
            }
            return p;
        }
        return undefined;
    }

    private getEventData(): IEventTreeData | undefined {
        return (this._current.persistable ?? true) ? this._state.getEventData(this._eventDefs) : undefined;
    }

    private startNextEvent(nextId: number): IDisplayInfo {
        const next = this._current.getNext(nextId);
        if (next) {
            this._existing = false;
            if (this.selectEventClass(next.eventName, next.targetClassName)) {
                this._state = next.getState(this._context, this._current, this._state);
                this.setCategory();
                this.resetHistory();
            }
        }
        return this.getInfo();
    }

    private buildCategories(): IPositional[] {
        const result: IPositional[] = [];
        const cats = this._categories.filter(x => (x.is_quick ?? false) && (x.is_visible ?? true));
        for (const cat of cats) {
            result.push(...EventTreeEngine.doGetEvents(true, cat.events, 'Quick Event'));
        }
        const categories = this._categories.filter(x => !(x.is_quick ?? false) && (x.is_visible ?? true))
            .sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
            .map((x, index) => {
                const position = x.position ?? index;
                return {
                    position: position,
                    label: x.label,
                    shortcut: FieldsCache.getShortcut(x.shortcut, position),
                    helpText: x.help_text ?? 'Category',
                    events: EventTreeEngine.doGetEvents(false, x.events, 'Event')
                };
            });
        result.push(...categories);
        return result;
    }

    private getInfo(addToHistory = true): IDisplayInfo {
        let info = this.initInfo();
        const currentStepId = this._userStepId ?? this.getNextStepId();
        if (currentStepId && currentStepId > 0) {
            const currentStep = info.steps?.find(x => x.id === currentStepId);
            if (currentStep) {
                currentStep.isSelected = true;
                switch (currentStep.semantics) {
                    case Semantics.Category:
                        this.setCategories(info);
                        break;
                    case Semantics.EventName:
                        info = this.setEvents(info, this._displayCategories.find(x => x.label === (this._browsedCategory?.label ?? this._category?.label)) as IEventCategory);
                        break;
                    case Semantics.Frame:
                    case Semantics.PlayerId:
                    case Semantics.TeamId:
                    case Semantics.LocationXY:
                        break;
                    default:
                        this.setOptions(info, currentStep);
                        break;
                }
            }
        } else if (info.isDone && !info.isPersistable && !info.isExisting) {
            info = this.doEventSaved(addToHistory, info) ?? info;
        }

        return this.setHistory(info, addToHistory);
    }

    private initInfo(): IDisplayInfo {
        const missingFields = this._current.allSteps.map(x => x.getMissing(this._state)).filter(x => x !== undefined);
        const eventData = this.getEventData();
        const info: IDisplayInfo = {
            steps: this.getUISteps(),
            isDone: missingFields.length === 0,
            isPersistable: this._current.persistable ?? true,
            isExisting: this._existing,
            canGoBack: !this._historyStack.isEmpty(),
            teamId: this.getValue(Semantics.TeamId),
            playerId: this.getValue(Semantics.PlayerId),
            frame: EventTreeEngine.toNumber(this.getValue(Semantics.Frame), false),
            xRinkCoord: EventTreeEngine.toNumber(this.getValue(Semantics.LocationX), true),
            yRinkCoord: EventTreeEngine.toNumber(this.getValue(Semantics.LocationY), true),
            missingFields: missingFields.length > 0 ? missingFields : undefined,
            eventData: missingFields.length === 0 ? eventData : undefined,
            flags: eventData?.flags,
        };
        EventTreeEngine.clearSelection(info.steps);
        return info;
    }

    private setCategories(info?: IDisplayInfo): IDisplayInfo {
        this._browsedCategory = undefined;
        info = info ?? this.initInfo();
        info.location = { type: PositionalTypes.Category, code: '' };
        info.matrixMessage = 'Select a category or a quick event';
        info.matrixItems = this._displayCategories;
        EventTreeEngine.clearSelection(info.matrixItems);
        if (this._category) {
            const selected = info.matrixItems.find(x => x.label === this._category!.label);
            if (selected) {
                selected.isSelected = true;
            }
        }
        return EventTreeEngine.selectStep(info, Semantics.Category);
    }

    private setEvents(info?: IDisplayInfo, currentCategory?: IEventCategory): IDisplayInfo {
        if (currentCategory?.events) {
            this._browsedCategory = currentCategory;
            info = info ?? this.initInfo();
            info.location = { type: PositionalTypes.Category, code: currentCategory.label };
            info.matrixMessage = `Select an event from the ${currentCategory.label} category`;
            info.matrixItems = currentCategory.events;
            currentCategory.events.forEach(x => { if ('isSelected' in x) { delete x.isSelected; } });
            const eventState = this._state.getStateValue(EVENT_NAME);
            if (eventState) {
                const selected = info.matrixItems.find(x => x.label === eventState.label);
                if (selected) {
                    selected.isSelected = true;
                }
            }

            return EventTreeEngine.selectStep(info, Semantics.EventName);
        }
        return this.setCategories(info);
    }

    private setOptions(info: IDisplayInfo, currentStep: IEventStep): IDisplayInfo {
        const prompt = this.getUIPrompt(currentStep.id);
        if (prompt) {
            info.location = { type: PositionalTypes.Step, step: currentStep };
            info.matrixMessage = prompt.prompt;
            info.matrixHelpText = prompt.helpText;
            info.matrixItems = prompt.options;
            EventTreeEngine.clearSelection(info.matrixItems);
            if (prompt.value !== undefined) {
                const selected = prompt.options.find(x => x.value === prompt.value);
                if (selected) {
                    selected.isSelected = true;
                }
            }
        }
        return info;
    }

    private doEventSaved(addToHistory: boolean, info?: IDisplayInfo): IDisplayInfo {
        if (!this._existing) {
            const nextEvents = this._current.allNextEvents.filter(x => x.matchState(this._state)).map((x: Next, index: number) => x.getUI(index));
            const required = nextEvents.find(x => x.required);
            if (required) {
                return this.setHistory(this.startNextEvent(required.id), addToHistory);
            }
            if (nextEvents.length > 0) {
                info = info ?? this.initInfo();
                // The event is saved, so its navigation history no longer applies; clearing it
                // disables the back button while the recommended events are displayed.
                this.resetHistory();
                info.location = { type: PositionalTypes.Recommended };
                info.matrixMessage = 'Recommended Events';
                info.matrixItems = [...nextEvents, OTHERS];
                return EventTreeEngine.doNoEvent(this.setHistory(info, addToHistory));
            }
            return this.setHistory(this.startEvent(this._getCarryOverData(), false, true), addToHistory);
        }
        return EventTreeEngine.doNoEvent(this.setHistory(this.getInfo(), addToHistory));
    }

    /**
     * Builds the initial data for the next fresh event so the team and player from the just-completed
     * event are kept, letting the user event consecutive actions for the same player without
     * re-selecting them. The player is only carried when it belongs to the carried-over team.
     */
    private _getCarryOverData(): IEventTreeData {
        const data: IEventTreeData = {};
        const teamId = this._state.getValueBySemantics(Semantics.TeamId);
        if (teamId === undefined) {
            return data;
        }

        const teamField = this._current.allSteps.find(x => x.field?.semantics === Semantics.TeamId)?.field;
        if (teamField) {
            data[teamField.output_field_name ?? teamField.name] = teamId;
        }

        const playerId = this._state.getValueBySemantics(Semantics.PlayerId);
        if (playerId !== undefined && this._state.getPlayerInfo(teamId, playerId) !== undefined) {
            const playerField = this._current.allSteps.find(x => x.field?.semantics === Semantics.PlayerId)?.field;
            if (playerField) {
                data[playerField.output_field_name ?? playerField.name] = playerId;
            }
        }
        return data;
    }

    /**
     * Clears the currently selected player when the chosen team is one the player does not belong to
     * (e.g. the opposing team is selected), since a carried-over player is invalid for the new team.
     */
    private _clearPlayerForOpposingTeam(teamId?: string): void {
        const playerStep = this._current.allSteps.find(x => x.field?.semantics === Semantics.PlayerId);
        if (playerStep?.field) {
            const playerId = this._state.getValue(playerStep.field.name);
            if (playerId && this._state.getPlayerInfo(teamId, playerId) === undefined) {
                this._state.setValue(playerStep.field, undefined, playerStep);
            }
        }
    }

    /**
     * Back-fills the team from the selected player so the team is always populated once a player is
     * chosen. Only applies when the team is currently unset; an already selected team is left as-is
     * (a player from the opposing team is rejected by validation before reaching this point).
     */
    private _backfillTeamFromPlayer(playerId?: string): void {
        if (!playerId) {
            return;
        }
        const teamStep = this._current.allSteps.find(x => x.field?.semantics === Semantics.TeamId);
        if (!teamStep?.field || this._state.getValue(teamStep.field.name)) {
            return;
        }
        const teamId = this._state.getTeamIdByPlayerId(playerId);
        if (teamId) {
            this._state.setValue(teamStep.field, teamId, teamStep);
            this._state.setVariants(teamStep.id);
        }
    }

    private pickFirstFlag(): boolean {
        for (const step of this._current.allSteps) {
            if (this.pickVisibleFlag(step)) {
                return true;
            }
        }
        return false;
    }

    private pickVisibleFlag(step: Step): boolean {
        if (FieldsCache.isFlag(step.field)) {
            const v = this._state.variants[step.id];
            if (step.getVisible(v)) {
                this._editStepId = step.id;
                return true;
            }
        }
        return false;
    }

    private doSetValue(step: Step | undefined, label: string, value?: string): string | undefined {
        if (step?.field) {
            const msg = step.validate(this._state, this._state.variants[step.id], value);
            if (msg) {
                return msg;
            }

            this._state.setValue(step.field, value, step);
            if (step.field.semantics === Semantics.TeamId) {
                this._clearPlayerForOpposingTeam(value);
            } else if (step.field.semantics === Semantics.PlayerId) {
                this._backfillTeamFromPlayer(value);
            }
            this._state.setVariants(step.id);
            if (step.field.semantics === Semantics.EventName) {
                if (this.selectEventClass(value)) {
                    this._state.setEventClass(this._current);
                } else {
                    return `Could not find configuration for event '${value}'.`;
                }
            }
            const fieldName = step.field.name;
            if (fieldName === EVENT_NAME || fieldName === EVENT_TYPE || fieldName === EVENT_OUTCOME) {
                this.setCategory();
            }
            return undefined;
        } else {
            return `Step ${label} was not found.`;
        }
    }

    private selectEventClass(eventName?: string, className?: string): boolean {
        let eventClass: EventClass | undefined;
        if (className) {
            eventClass = this._events.getClass(className);
        } else if (eventName) {
            eventClass = this._events.selectClass(eventName);
        } else if (!this._existing) {
            eventClass = this._events.empty;
        }
        if (eventClass) {
            this._current = eventClass;
            return true;
        }
        this._current = this._events.empty;
        return false;
    }

    private setCategory(): void {
        this._category = undefined;
        const name = this.getValueByName(EVENT_NAME);
        if (!name) {
            return;
        }
        const type = this.getValueByName(EVENT_TYPE);
        const outcome = this.getValueByName(EVENT_OUTCOME);

        let lastScore = -1;
        let lastCategory: string | undefined;
        let lastEvent: string | undefined;

        for (const category of this._categories) {
            if (category.events) {
                for (const event of category.events) {
                    if (event.event_name === name) {
                        const score = EventTreeEngine.matchEvent(event, type, outcome);
                        if (score > lastScore) {
                            lastScore = score;
                            lastCategory = category.label;
                            lastEvent = event.label;
                            break;
                        }
                    }
                }
            }
        }

        if (lastCategory && lastEvent) {
            this._category = { id: CATEGORY_STEP_ID, label: lastCategory, hasValue: true, isValid: true, semantics: Semantics.Category, position: 0 };
            this._state.setEventLabel(lastEvent);
        }
    }

    private getCategoryPrompt(): IStepPrompt {
        return {
            id: CATEGORY_STEP_ID,
            fieldName: 'category',
            semantics: Semantics.Category,
            prompt: '',
            options: [],
            required: false,
            value: this._category?.label ?? ''
        };
    }

    private setHistory(info: IDisplayInfo, addToHistory: boolean): IDisplayInfo {
        const historyLoc = info.location;
        if (historyLoc) {
            if (addToHistory && this._historyLoc) {
                if (this._historyLoc.type !== historyLoc.type || this._historyLoc.step?.id !== historyLoc.step?.id || this._historyLoc.code !== historyLoc.code) {
                    this._historyStack.push(this._historyLoc);
                }
            }
            this._historyLoc = historyLoc;
        } else if (addToHistory && this._historyLoc) {
            this._historyStack.push(this._historyLoc);
        }
        info.canGoBack = !this._historyStack.isEmpty();
        return info;
    }

    private resetHistory(): void {
        this._historyLoc = undefined;
        this._historyStack.clear();
    }

    private updateInfo(info: IDisplayInfo): void {
        this._displayInfoData = info;
        this._displayInfoSubject.next(info);
    }

    private static doGetEvents(isQuick: boolean, events?: IEventData[], defaultHelpText?: string): INewEvent[] {
        return events?.filter(x => (x.is_visible ?? true)).map((x, index) => {
            const position = x.position ?? index;
            return {
                position: position,
                label: x.label,
                shortcut: FieldsCache.getShortcut(x.shortcut, position),
                helpText: x.help_text ?? defaultHelpText,
                name: x.event_name ?? '',
                type: x.type,
                outcome: x.outcome,
                flags: x.set_flags,
                isQuick: isQuick,
            };
        }) ?? [];
    }

    private static getPositionalType(obj: IPositional): PositionalTypes | undefined {
        if (typeof obj === 'object' && obj !== null && obj !== undefined) {
            if ('value' in obj && typeof obj.value === 'string') {
                return PositionalTypes.Option;
            }
            if ('name' in obj && typeof obj.name === 'string') {
                return PositionalTypes.Event;
            }
            if ('events' in obj) {
                return PositionalTypes.Category;
            }
            if ('required' in obj && typeof obj.required === 'boolean') {
                return PositionalTypes.Recommended;
            }
            if ('hasValue' in obj && typeof obj.hasValue === 'boolean') {
                return PositionalTypes.Step;
            }
        }
        return undefined;
    }

    private static clearSelection(list?: IPositional[]): void {
        if (list) {
            list.forEach(x => { if ('isSelected' in x) { delete x.isSelected; } });
        }
    }

    private static selectStep(info: IDisplayInfo, semantics: Semantics): IDisplayInfo {
        if (info.steps) {
            EventTreeEngine.clearSelection(info.steps);
            const step = info.steps.find(x => x.semantics === semantics);
            if (step) {
                step.isSelected = true;
            }
        }
        return info;
    }

    private static doNoEvent(info: IDisplayInfo): IDisplayInfo {
        info.isDone = false;
        info.isPersistable = false;
        info.isExisting = false;
        delete info.steps;
        delete info.missingFields;
        delete info.eventData;
        EventTreeEngine.clearSelection(info.matrixItems);
        return info;
    }

    private static toNumber(value: string | undefined, asFloat: boolean): number | undefined {
        if (value) {
            return asFloat ? parseFloat(value) : parseInt(value);
        }
        return undefined;
    }

    private static matchEvent(event: IEventData, type?: string, outcome?: string): number {
        let score = 0;
        if (event.type) {
            if (type === event.type) {
                score += 1;
            } else {
                return -1;
            }
        }
        if (event.outcome) {
            if (outcome === event.outcome) {
                score += 1;
            } else {
                return -1;
            }
        }
        return score;
    }
}
